import * as React from 'react'

import {
  Button,
  Link,
  Popover,
  PopoverContent,
  PopoverTrigger,
  SimpleGrid,
  Stack,
  Text,
} from '@chakra-ui/react'
import { graphql, useStaticQuery } from 'gatsby';

import { PopoverIcon } from './PopoverIcon'
import { items } from './_data'
import useAuth from '../hooks/useAuth';

const CategoriesPopover = () => {

   const query = useStaticQuery(graphql`
    {
      allWpProductCategory(filter: {name: {ne: "Ophthalmology", nin: "Body Sculpting"}}) {
        nodes {
          name
          slug
          count
        }   
      }
    }
  `)

  const data = query.allWpProductCategory.nodes

  const { loggedIn } = useAuth();
  
  // const categoriesToExclude = ["Botulinum Toxins",  "Gynecology", ]
  const categoriesToExclude = [ ]

  const categoriesToHide = ["Body Sculpting", "Ophthalmology", "Orthopedic Injectables", "Filler Removal", "Ophthalmology", "Rheumatology", "Osteoporosis"]
    
  const filteredCategories = React.useMemo(() => {
    if(!loggedIn) {
      return data.filter((item : any) => {
         return !categoriesToHide.includes(item.name)
    }) 
    } else {
      return data.filter((item: any) => {
        return !categoriesToHide.includes(item.name)
      })
    } 
  
    return data
    },[data, loggedIn])

  return (
    <Popover trigger="click" openDelay={0} placement="bottom" defaultIsOpen={false} gutter={5}>
      {({ isOpen }) => (
        <>
          <PopoverTrigger>
            <Button variant="solid" size="sm" fontSize="sm" color="white" bg="blue.500" rightIcon={<PopoverIcon isOpen={isOpen} />}>
              Categories
            </Button>
          </PopoverTrigger>
          <PopoverContent p="5" width='sm' right="-16px">
            <SimpleGrid columns={{ base: 1, md: 2 }} columnGap="6" rowGap="2">
              {filteredCategories.map((item: any) => {
                if (item.count !== null) {
                   return <Link variant="menu" href={`/category/${item.slug}`} key={item.databaseId}>
                  <Stack spacing="4" direction="row">
                    <Text fontWeight="medium">{item.name}</Text>
                  </Stack>
                </Link>
                } else {
                  return <></>
                }
               
              })}
            </SimpleGrid>
          </PopoverContent>
        </>
      )}
      </Popover>
  )
}

export default CategoriesPopover